<template>
 <div class="MainBodyBox">
  <router-view style="width: 100%;height: 100%;"/>
 </div>

</template>

<style>
.MainBodyBox {
  width: 100vw;
  height: 100vh;
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
</style>
